import { Breadcrumb as Breadcrumb$2, Link } from './style.js';
import Icon from '../Icon/Icon.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { USER_INTERFACE_ARROW_04_RIGHT } from '../IconPath/USER_INTERFACE_ARROW_04_RIGHT.js';

var Breadcrumb = function Breadcrumb(props) {
  var name = props.name,
    uri = props.uri,
    desktopOnly = props.desktopOnly,
    target = props.target,
    position = props.position;
  if (!name || !uri || !position) {
    return false;
  }
  return /*#__PURE__*/jsxs(Breadcrumb$2, {
    itemScope: true,
    itemProp: "itemListElement",
    itemType: "https://schema.org/ListItem",
    desktopOnly: desktopOnly,
    children: [/*#__PURE__*/jsxs(Link, {
      itemProp: "item",
      href: uri,
      target: target,
      name: name,
      children: [/*#__PURE__*/jsx("span", {
        itemProp: "name",
        children: name
      }), /*#__PURE__*/jsx("meta", {
        itemProp: "position",
        content: position
      })]
    }), /*#__PURE__*/jsx(Icon, {
      path: USER_INTERFACE_ARROW_04_RIGHT,
      className: "sg-breadcrumbs__arrow-icon",
      size: "xxxs"
    })]
  });
};
Breadcrumb.defaultProps = {
  name: null,
  uri: null,
  target: '_self',
  position: null,
  desktopOnly: null
};
var Breadcrumb$1 = Breadcrumb;

export { Breadcrumb$1 as default };
//# sourceMappingURL=Breadcrumb.js.map
